/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Formik, Form, Field, FieldArray } from "formik";

import MaskedInput from "react-text-mask";
import InputField from "~components/Form/components/InputField";
import ContainerForm from "~components/Form/components/ContainerForm";
import mask from "~services/utils/mask";
import prepareForOptions from "~services/utils/prepareForOptions";
import useReceiver from "../hooks/useReceiver";
import * as yup from "yup";
import { initialPath } from "~misc/paths";
import Select from "~components/Form/components/Select";
import useModalAction from "~components/Modal/hooks/useModalAction";
import ModalAction from "~components/Modal/ModalAction";
import { SaveIndexBD, removeLocalStorage } from "~services/utils/SaveIndexBD";
import { GetIndexBD } from "~services/utils/GetIndexBD";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSalvarRecebedor } from "~pages/Wallet/hooks/useWallet";
import Multiselect from "multiselect-react-dropdown";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import Loader from "~components/Form/components/Loader";
import { DeleteEdit } from "~misc/icons";
import originControl from "~services/utils/originControl";
import AddressForm from "~components/Form/components/AddressForm";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useTrilha from "~/fetchs/useTrilha";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import useGrupoSegmento from "~/fetchs/useGrupoSegmento";
import useSegmento from "~/fetchs/useSegmento";
import useUsuario from "~/fetchs/useUsuario";
import Info from "~components/Form/components/Info";
import useParametros from "~fetchs/useParametros";
import ExcluirModal from "~pages/PricesTable/components/Modal/ExcluirModal";
import { getLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";
import useProdutoConcorrente from "~/fetchs/useProdutoConcorrente";
import useCargo from "~/fetchs/useCargo";
import {
  // classificacaoFiscalDefaultOptions,
  recebimentoDefaultOptions,
} from "~services/utils/defaultOptions";
import useAll from "~fetchs/useAll";
import useSelect from "~components/Form/hooks/useSelect";
import { permiteNomeObra, normalizeNomeObra } from "~services/utils/nomeObra";

import { useToast } from "@chakra-ui/react";
import useEquipeVenda from "~fetchs/useEquipeVenda";
import useEscritorioVenda from "~fetchs/useEscritorioVenda";
import ModalContatoSalvos from "~components/Modal/ModalContatoSalvo";
import ModalContato from "~components/Modal/ModalContato";
import { updateConvertedClient } from '../../helpers/updateConvertedClient';


const ReceiverForm = ({ setBackRoute }) => {
  const { usuario } = useUsuario();
  const newContato = {
    nome: "",
    sobrenome: "",
    cargoId: null,
    email: "",
    telefone: "",
    celular: "",
  };
  const [formModalValues, setFormModalValues] = useState({});
  const [formModalValuesCreate, setFormModalValuesCreate] = useState({});

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const formikRef = useRef();
  const ArrayContatoRef = useRef();
  const [loading, setLoading] = useState(false);

  const { getOrigem, origens, origin, getPersistentParameters, setPersistentParameters, persistentParameters } =
    originControl();

  const { optionFunilObraProdutos } = useProdutoConcorrente({ formikRef });

  const { formatNumber, cepMask } = mask();
  const { validationSchema, initialValues, valuess, setValue, setinitialValues } = useReceiver(0, false);
  const {
    isModalOpen,
    closeModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    openModal,
    setSubmessageStatus,
    submessageStatus,
  } = useModalResponse();
  const {
    isModalOpenAction: isModalContatoSalvar,
    closeModalAction: closeModalContatoSalvar,
    openModalAction: openModalContatoSalvar,
  } = useModalAction();

  const { isModalOpenAction, closeModalAction, openModalAction, setModalOpenAction } = useModalAction();


  //States
  const [localidade, setLocalidade] = useState("");
  const [additionalContacts, setAdditionalContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState({});

  const [emissorData, setEmissorData] = useState({});
  const [recebedorData, setRecebedorData] = useState({});
  const [converterProspect, setConverterProspect] = useState({});
  const [dataComingBack, setDataComingBack] = useState({});

  //OPTIONS
  // const classificacaoFiscalOptions = classificacaoFiscalDefaultOptions;
  const recebimentoOptions = recebimentoDefaultOptions;
  const { onChangeTipoPessoa, tipoPessoaSelect, isPessoaFisica, recebimentoSelect, onChangeRecebimento } = useAll(formikRef);

  async function CheckEmissor() {
    const values = await GetIndexBD("form-new-emissor");
    if (Object.entries(values).length > 0) {
      setEmissorData(values);
    } else {
      navigate(`${initialPath}/carteira`);
    }
  }

  //IndexsDB
  const { optionsTrilha, trilha, onChangeTrilha,trilhas, trilhaSelect, SetSelectTrilha, trilhasObjId, trilhasObjCodigo, trilhasObjNome } = useTrilha(formikRef);
  const { optionsCargo, cargoSelect, handleCargoChange, SetSelectCargo } = useCargo(formikRef);

  const {
    gruposCentralizadores,
    optionGruposCentralizadores,
    grupoCentralizadorSelect,
    onChangeGrupoCentralizador,
    SetSelectGrupoCentralizador,
  } = useGrupoCentralizador(formikRef);
  const { optionsGrupoSegmento, grupoSegmento, grupoSegmentoSelect, onChangeGrupoSegmento, SetSelectGrupoSegmento } =
    useGrupoSegmento({ formikRef, trilha });
  const { optionsEquipe, equipe, SetSelectEquipe,clearEquipe, onChangeEquipe, equipeSelect } = useEquipeVenda(formikRef);
  const { optionsEscritorio, escritorio, SetSelectEscritorio, clearEscritorio, onChangeEscritorio, escritorioSelect } = useEscritorioVenda(formikRef,  equipeSelect);
  const { optionsSegmento, segmentoSelect, onChangeSegmento, SetSelectSegmento } = useSegmento(
    grupoSegmento,
    formikRef
  );
  const { toObjectSlug } = useParametros();
  const grupoCentralizadorConstrutoraSelect = useSelect("grupoCentralizadorConstrutoraId");
  const grupoCentralizadorConstrutoraParam = toObjectSlug["grupos-centralizador-construtoras"];
  const grupoCentralizadorConstrutoraOptions = useMemo(() => {
    const filtrados = (gruposCentralizadores || []).filter((grupo) => grupo.trilhaId === trilha);
    return prepareForOptions(filtrados, ["codigo", "nome"], "id");
  }, [gruposCentralizadores, trilha]);
  const filteredGrupoCentralizador = useMemo(() => (gruposCentralizadores || []).filter((grupo) => grupo.trilhaId === trilha), [gruposCentralizadores, trilha]);
  const [grupoOptionsState, setGrupoOptionsState] = useState([]);
  const [grupoOptionsLoaded, setGrupoOptionsLoaded] = useState(false);
  const [selectedGrupoOption, setSelectedGrupoOption] = useState(null);
  const [grupoLoading, setGrupoLoading] = useState(true);

  const loadGrupoOptions = useCallback(() => {
    if ( grupoOptionsLoaded ) return;
    setGrupoLoading(true);
    setTimeout(() => {
      const opts = prepareForOptions(filteredGrupoCentralizador, ["codigo", "nome"], "id");
      setGrupoOptionsState(opts);
      setGrupoOptionsLoaded(true);
      setGrupoLoading(false);
    }, 50);
  }, [filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading]);
  const trilhasPermitidas = useMemo(() => {
    const raw = grupoCentralizadorConstrutoraParam?.valor || "";
    const codigos = raw
      .split(",")
      .map((codigo) => codigo.trim().toUpperCase())
      .filter(Boolean);
    return codigos
      .map((codigo) => trilhasObjCodigo?.[codigo]?.id || trilhasObjNome?.[codigo]?.id)
      .filter(Boolean);
  }, [grupoCentralizadorConstrutoraParam?.valor, trilhasObjCodigo, trilhasObjNome]);
  const isTrilhaPermitida = trilhasPermitidas.includes(trilha);
  const imoTrilhaId =
    trilhasObjNome?.IMO?.id || trilhasObjCodigo?.IMO?.id || trilhasObjCodigo?.["410"]?.id;
  const isTrilhaIMO = imoTrilhaId ? String(trilha) === String(imoTrilhaId) : false;
  const exibirNomeObra = permiteNomeObra(trilhasObjId?.[`key-${trilha}`]);

  const acessoJornadaFunil = ["IMO", "INFRA"].includes(
    trilhas.find((item) => String(item.id) === String(trilha))?.nome?.toUpperCase()
  ) && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');

  const prospectOrigem = persistentParameters.split(',').includes(origens.conversao_prospect)
    ? Number(searchParams.get("prospect-origem") || converterProspect?.id || (emissorData?.conversao ? emissorData.id : 0)) : 0;

  const [firstChangeCidade, setFirstChangeCidade] = useState(false);
  const onChangeGrupoCentralizadorConstrutora = (e) => {
    const value = e?.value ?? null;
    grupoCentralizadorConstrutoraSelect.upDateValue(value || "");
    grupoCentralizadorConstrutoraSelect.upDateDefaultValue(e || "");
    formikRef.current?.setFieldValue("grupoCentralizadorConstrutoraId", value);
    setTimeout(() => formikRef.current?.setFieldTouched("grupoCentralizadorConstrutoraId", true));
  };

  useEffect(() => {
    const currentId = formikRef.current?.values?.grupoCentralizadorConstrutoraId;
    if (!currentId) {
      setSelectedGrupoOption(null);
      return;
    }

    if (grupoOptionsLoaded) {
      const match = grupoOptionsState.find((opt) => String(opt.value) === String(currentId));
      if (match) {
        setSelectedGrupoOption(match);
        return;
      }
    }

    const found = (gruposCentralizadores || []).find((g) => String(g.id) === String(currentId));
    if (found) setSelectedGrupoOption({ value: found.id, label: found.nome || found.codigo });
  }, [grupoOptionsLoaded, grupoOptionsState, gruposCentralizadores]);

  useEffect(() => {
    if (!formikRef.current) return;

    if (!isTrilhaPermitida) {
      if (formikRef.current.values?.grupoCentralizadorConstrutoraId) {
        onChangeGrupoCentralizadorConstrutora(null);
      }
      return;
    }

    if (!grupoCentralizadorConstrutoraOptions?.length) return;

    const currentId = formikRef.current.values?.grupoCentralizadorConstrutoraId;
    if (currentId === null || currentId === undefined || currentId === "") return;

    const currentOption = grupoCentralizadorConstrutoraOptions.find(
      (opt) => String(opt.value) === String(currentId)
    );
    if (!currentOption) return;

    onChangeGrupoCentralizadorConstrutora(currentOption);
  }, [isTrilhaPermitida, grupoCentralizadorConstrutoraOptions, trilha]);

  useEffect(() => {
    if (!grupoOptionsLoaded && isTrilhaPermitida && filteredGrupoCentralizador && filteredGrupoCentralizador.length > 0) {
      loadGrupoOptions();
    }
  }, [isTrilhaPermitida, filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading, loadGrupoOptions]);


  //FunctionsIndexDB
  async function getConverterProspect() {
    const con = getLocalStorage("conversao-prospect", true);
    setConverterProspect(con);
  }

  async function fetchConverterProspect() {
    if (converterProspect && converterProspect?.id) {
      if (persistentParameters.includes(origens.conversao_prospect)) {
        formikRef.current.setFieldValue("id", converterProspect?.id);
        formikRef.current.setFieldValue("codigoProspect", converterProspect?.codigoProspect);
        formikRef.current.setFieldValue("bairro", converterProspect?.endereco?.bairro);
        formikRef.current.setFieldValue("cep", converterProspect?.endereco?.cep);
        // formikRef.current.setFieldValue("classificacaoFiscal", converterProspect?.classificacaoFiscal)
        formikRef.current.setFieldValue("complemento", converterProspect?.complemento);
        formikRef.current.setFieldValue("descargaCliente", converterProspect?.descargaCliente);
        formikRef.current.setFieldValue("dataNascimento", converterProspect?.dataNascimento);
        formikRef.current.setFieldValue("grupoCentralizadorId", converterProspect?.grupoCentralizadorId);
        formikRef.current.setFieldValue(
          "grupoCentralizadorConstrutoraId",
          converterProspect?.grupoCentralizadorConstrutoraId ?? null
        );
        formikRef.current.setFieldValue("numero", converterProspect?.endereco?.numero);
        formikRef.current.setFieldValue("rua", converterProspect?.endereco?.rua);
        formikRef.current.setFieldValue("produtos", converterProspect?.produtos);
        formikRef.current.setFieldValue("nomeObra", converterProspect?.nomeObra ?? "");
        await formikRef.current.setFieldValue("contatos", converterProspect?.contatos);
        SetSelectCargo(converterProspect?.contatos ?? []);

        setBackRoute(
          persistentParameters.includes(origens.cadastro_emissor)
            ? `${initialPath}/carteira/emissor/novo?origem=${origens.edicao_recebedor}&pp=${persistentParameters}`
            : `${initialPath}/carteira/busca/online?origem=${origens.edicao_recebedor}&pp=${persistentParameters}`
        );
      }
    }
  }

  async function checkOrigem() {
    const pp = await getPersistentParameters();
    const origem = getOrigem();

    CheckEmissor();

    if (pp.includes(origens.conversao_prospect)) {
      getConverterProspect();
    }

    switch (origem) {
      case origens.solicitar_credito:
        setDataComingBack(await GetIndexBD("retornar-dados-recebedor"));
        break;
    }

    setPersistentParameters(pp.length > 0 ? pp.join(",") : "");
  }

  useEffect(() => {
    if (converterProspect) fetchConverterProspect();
  }, [converterProspect]);

  useEffect(() => {
    if (dataComingBack && Object.entries(dataComingBack).length > 0) {
      SetSelects(dataComingBack);

      formikRef.current.setFieldValue("id", dataComingBack.id);
      formikRef.current.setFieldValue("descargaCliente", dataComingBack.descargaCliente);
      formikRef.current.setFieldValue("dataNascimento", dataComingBack.dataNascimento);
      formikRef.current.setFieldValue("grupoCentralizadorId", dataComingBack.grupoCentralizadorId);
      formikRef.current.setFieldValue(
        "grupoCentralizadorConstrutoraId",
        dataComingBack.grupoCentralizadorConstrutoraId ?? null
      );
      formikRef.current.setFieldValue("bairro", dataComingBack.bairro);
      formikRef.current.setFieldValue("cep", dataComingBack.cep);
      formikRef.current.setFieldValue("complemento", dataComingBack.complemento);
      formikRef.current.setFieldValue("numero", dataComingBack.numero);
      formikRef.current.setFieldValue("rua", dataComingBack.rua);
      formikRef.current.setFieldValue("bairro", dataComingBack.bairro);
      formikRef.current.setFieldValue("produtos", dataComingBack.produtos);
      formikRef.current.setFieldValue("nomeObra", dataComingBack.nomeObra ?? "");
      formikRef.current.setFieldValue("contatos", dataComingBack.contatos);

      removeLocalStorage("retornar-dados-recebedor");
    }
  }, [dataComingBack]);

  useEffect(() => {
    checkOrigem();
  }, []);

  //Requests

  const onSuccess = async (data) => {
    setLoading(false);
    
    const clienteId = data?.data?.clienteRecebedor?.id;

    if (navigator.onLine && persistentParameters.split(',').includes(origens.conversao_prospect)
      && prospectOrigem > 0 && clienteId) {
      await updateConvertedClient(prospectOrigem, clienteId);
    }

    if (acessoJornadaFunil && clienteId) {
      const parametros = new URLSearchParams({ origem: origens.solicitar_credito, "limite-credito": "pulado", pp: persistentParameters });
      if (prospectOrigem > 0) parametros.set("prospect-origem", prospectOrigem);
      navigate(`${initialPath}/carteira/recebedor/${clienteId}?${parametros}`);
      return;
    }

    navigate(`${initialPath}/carteira/solicitacoes`);
  }

  const onError = () => {
    setLoading(false);
  }

  const recebedorSalvar = useSalvarRecebedor(recebedorData, onSuccess, onError);

  function SetSelects(data) {
    SetSelectTrilha(data?.trilhaId);
    SetSelectGrupoCentralizador(data?.grupoCentralizadorId);
    SetSelectSegmento(data?.segmentoId);
    SetSelectGrupoSegmento(data?.grupoSegmentoId);

    formikRef.current.setFieldValue(
      "grupoCentralizadorConstrutoraId",
      data?.grupoCentralizadorConstrutoraId ?? null
    );

    formikRef.current.setFieldValue("codigoVendedor", usuario?.codigo);
    formikRef.current.setFieldValue("descargaCliente", data?.descargaCliente);
    formikRef.current.setFieldValue("descargaFumaca", data?.descargaFumaca);
  }

  useEffect(() => {
    if (Object.keys(emissorData).length > 0) {
      SetSelects(emissorData);

      const origem = getOrigem();
      switch (origem) {
        case origens.busca_online:
          setBackRoute(`${initialPath}/carteira/busca/online`);
          break;
        default:
          saveLocalStorage("retornar-dados-emissor", emissorData, true);
          setBackRoute(
            `${initialPath}/carteira/emissor/novo?origem=${origens.edicao_recebedor}&pp=${persistentParameters}`
          );
          break;
      }
    }
  }, [emissorData]);

  useEffect(() => {
    if (usuario?.codigo) {
      setinitialValues({
        ...initialValues,
        codigoVendedor: usuario?.codigo,
      });

      formikRef?.current?.setFieldValue("codigoVendedor", usuario?.codigo ?? "");

      setTimeout(() => {
        formikRef?.current?.setFieldTouched("codigoVendedor", true);
      }, 1000);
    }
  }, [usuario?.codigo]);

  async function StatusRetorno() {
    setModalOpenAction(false);
    removeLocalStorage("form-new-emissor");
    removeLocalStorage("form-new-recebedor");
    removeLocalStorage("conversao-prospect");
  }

  useEffect(() => {
    if (Object.keys(recebedorData).length > 0) {
      setLoading(true);
      recebedorSalvar();
    }
  }, [recebedorData]);
  const disabledButtonSubmit = () => {
    let buttonSubmit = document.querySelector(".send-button");
    buttonSubmit.classList.add("disabled-submit");
  }

  function SimLimite() {
    disabledButtonSubmit();
    removeLocalStorage("conversao-prospect");
    
    const parametros = new URLSearchParams({ origem: origens.cadastro_recebedor, pp: persistentParameters });
    if (prospectOrigem > 0) parametros.set("prospect-origem", prospectOrigem);
    navigate(`${initialPath}/carteira/credito/novo?${parametros}`);
  }

  async function NaoLimite() {
    disabledButtonSubmit();
    const values = await GetIndexBD("form-new-recebedor");
    closeModalAction();

    const concorrente = values.concorrente?.checkboxSim;
    const produtos = [];
    if (concorrente) {
      values.produtos.map((item) => {
        produtos.push(item.value);
      });
    }

    const toSend = {
      clienteRecebedor: {
        ...values,
        dataNascimento: emissorData?.dataNascimento?.trim() ?? null,
        concorrente: concorrente,
        produtos: produtos,
      },
      clienteEmissor: {
        ...emissorData,
        dataNascimento: emissorData?.dataNascimento?.trim() ?? null,
      },
    };

    setRecebedorData(toSend);
  }
  const [removeBlock, setremoveBlock] = useState({
    arrayContatos: [],
    index: null,
  });
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [indexBlock, setIndexBlock] = useState(null);

  function RemoveBlock() {
    removeBlock.arrayContatos[0].remove(removeBlock.index);
    setIsConfirmationOpen(false);
  }
  function HandleRemoveBlock(arrayContatos, index) {
    setIsConfirmationOpen(true);
    setIndexBlock(index);

    setremoveBlock((prevState) => ({
      // Mantenha os valores antigos do estado
      ...prevState,
      // Atualize o arrayContatos adicionando um novoContato
      arrayContatos: [...prevState.arrayContatos, arrayContatos],
      index: index,
    }));
  }

  function HandleRemoveBlockClosed() {
    setIsConfirmationOpen(false);
  }
  const toast = useToast();
  const deleteContato = (index) => {


    if (Array.isArray(initialValues.contatos)) {
      initialValues.contatos = initialValues.contatos.filter(
        (_, i) => i !== index
      );
    }

    setinitialValues({
      ...initialValues,
      contatos: initialValues.contatos
    });

     toast({
        title: `Contato deletado com sucesso!`,
        description: "",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right"
      });
    initialValues.contatos.length <= 1 ? closeModalContatoSalvar() : null;
  };

  const editContato = (index) => {

    if (Array.isArray(initialValues.contatos)) {
      const contato = initialValues.contatos[index];

      setSelectedContact(contato);
      closeModalContatoSalvar();
      openModal();
    }
  };


   const storedTrilha = useRef(0);
    if (trilha !== 0 && trilha !== storedTrilha.current) {
      console.log(`Trilha mudou de ${storedTrilha.current} para ${trilha}`);
      storedTrilha.current = trilha;
      clearEscritorio();
      clearEquipe();
    }



  return (
    <>
      <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validateOnBlur={true}
      validationSchema={yup.object().shape({
        ...validationSchema.fields,
        contatos: emissorData.tipo === 1 ? undefined : validationSchema.fields.contatos,
      })}
      onSubmit={async (values, { setFieldError }) => {
        if (isTrilhaIMO && isTrilhaPermitida && !values.grupoCentralizadorConstrutoraId) {
          setFieldError(
            "grupoCentralizadorConstrutoraId",
            "Grupo Centralizador Construtoras e obrigatorio"
          );
          return;
        }

        const primeiroContato = values.contatos[0];
        if (formModalValues?.contatos && formModalValues.contatos.length > 0) {
          values.contatos = [primeiroContato, ...formModalValues.contatos];
        } else {
          values.contatos = [primeiroContato];
        }

        values.nomeObra = normalizeNomeObra(values.nomeObra, exibirNomeObra);

         try {
          SaveIndexBD("form-new-recebedor", values);
          openModalAction();
        } finally {
          setLoading(false);
        }
      }}
    >
      {({ values, errors, touched, setFieldValue, setFieldTouched, isSubmitting }) => (
   <>
          <Form className="mt-[-4rem] mb-10 relative" id="recebedor">

            <div className={loading ? "relative spinner__form-active" : "relative"}>
              <ContainerForm title="Dados Cadastrais">
                <div className="grid gap-x-4 md:grid-cols-1 lg:grid-cols-2">
                  <InputField
                    labelName="Código SAP:"
                    inputName="codigoSAP"
                    inputMask="offmask"
                    inputType="text"
                    // isDisabled={true}
                    isDisabled={!!initialValues.codigoVendedor}
                  />
                  <InputField
                    labelName="Código Vendedor:"
                    inputName="codigoVendedor"
                    inputMask="offmask"
                    inputType="text"
                    isDisabled={true}
                  />
                </div>

                <AddressForm formikRef={formikRef} dataComingBack={dataComingBack} emissorData={emissorData} />
                {exibirNomeObra && (
                  <InputField labelName="Nome da Obra:" inputName="nomeObra" inputMask="offmask" inputType="text" />
                )}
              </ContainerForm>

                       <FieldArray
              name="contatos"
              render={(arrayContatos) => {
                ArrayContatoRef.current = arrayContatos;
                return (
                  <div className="container relative">
                    <ContainerForm title="Dados Pessoais">
                      {values.contatos.map((data, index) => (
                        <>
                          <div
                            className={`relative rounded-lg grid gap-x-4 md:grid-cols-1 lg:grid-cols-2 ${index % 2 != 0 ? " bg-[#DAE8F9] p-3" : ""
                              } ${values.contatos.length > 1 ? " pt-12 " : ""}`}
                            key={index}
                          >
                            {values.contatos.length > 1 && (
                              <button
                                type="button"
                                className="scale-75 absolute top-0 right-0"
                                onClick={() => HandleRemoveBlock(arrayContatos, index)}
                              >
                                <DeleteEdit />
                              </button>
                            )}
                            <InputField
                              className="bg-white"
                              labelName="Nome Contato:"
                              inputName={`contatos[${index}].nome`}
                              inputMask="offmask"
                              inputType="text"
                              difference={true}
                              isRequired={emissorData.tipo === 1 ? false : true}
                            />
                            <InputField
                              labelName="Sobrenome Contato:"
                              inputName={`contatos[${index}].sobrenome`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired={emissorData.tipo === 1 ? false : true}
                              difference={true}
                            />
                            <Select
                              name={`contatos[${index}].cargoId`}
                              label="Cargo:"
                              placeholder=""
                              options={optionsCargo}
                              value={
                                data.cargoId
                                  ? {
                                      label:
                                        data.cargo ||
                                        optionsCargo.find((o) => String(o.value) === String(data.cargoId))?.label ||
                                        "",
                                      value: data.cargoId,
                                    }
                                  : cargoSelect.value(index) || null
                              }
                              onChange={(e) => {
                                setFieldValue(`contatos[${index}].cargoId`, e.value);
                                setFieldValue(`contatos[${index}].cargo`, e.label);
                                setTimeout(() => setFieldTouched(`contatos[${index}].cargoId`, true));
                              }}
                              errors={errors.contatos && errors?.contatos[index]?.cargoId}
                              touched={touched.contatos && touched?.contatos[index]?.cargoId}
                              isRequired={emissorData.tipo === 1 ? false : true}
                            />
                            <InputField
                              labelName="Email do Contato:"
                              inputName={`contatos[${index}].email`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired={emissorData.tipo === 1 ? false : true}
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 1:"
                              inputName={`contatos[${index}].telefone`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              isRequired={emissorData.tipo === 1 ? false : true}
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 2:"
                              inputName={`contatos[${index}].celular`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              difference={true}
                            />
                          </div>
                          <div className="flex items-center">
                            {((values.contatos.length > 1 && index == values.contatos.length - 1) ||
                              values.contatos.length == 1) && (
                                <button
                                  type="button"
                                  className="mt-4 py-2 px-3 bg-primaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search"
                                  onClick={() => arrayContatos.push(newContato)}
                                >
                                  Adicionar um novo contato
                                </button>
                              )}
                          </div>
                        </>
                      ))}
                    </ContainerForm>
                  </div>
                );
              }}
            ></FieldArray>


              <ContainerForm title="Informações Adicionais">
                <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-3">
                  <Select
                    name="trilhaId"
                    label="Trilha Global:"
                    placeholder="Trilha Global:"
                    options={optionsTrilha}
                    noOptionsMessage="Trilha não encontrado"
                    onChange={(e) => onChangeTrilha(e)}
                    errors={errors.trilhaId}
                    touched={touched.trilhaId}
                    isRequired
                    {...trilhaSelect}
                  />
                  {/* <Select
                    name="classificacaoFiscal"
                    label="Classificação Fiscal:"
                    placeholder="Classificação Fiscal:"
                    options={classificacaoFiscalOptions}
                    noOptionsMessage="Classificação não encontrada"
                    onChange={(e) => onChangeClassificacaoFiscal(e)}
                    errors={errors.classificacaoFiscal}
                    touched={touched.classificacaoFiscal}
                    {...classificacaoFiscalSelect}
                  /> */}

                  <Select
                    name="grupoSegmentoId"
                    label="Grupo Segmento:"
                    placeholder="Grupo Segmento:"
                    options={optionsGrupoSegmento}
                    noOptionsMessage="Grupo não encontrado"
                    onChange={(e) => onChangeGrupoSegmento(e)}
                    isDisabled={!values.trilhaId}
                    errors={errors.grupoSegmentoId}
                    touched={touched.grupoSegmentoId}
                    {...grupoSegmentoSelect}
                    isRequired
                  />
                  <Select
                    name="segmentoId"
                    label="Segmento:"
                    placeholder="Segmento:"
                    options={optionsSegmento}
                    noOptionsMessage="Grupo não encontrado"
                    onChange={(e) => onChangeSegmento(e)}
                    isDisabled={!values.grupoSegmentoId}
                    errors={errors.segmentoId}
                    touched={touched.segmentoId}
                    {...segmentoSelect}
                    isRequired
                  />
                  <Select
                    name="grupoCentralizadorId"
                    label="Grupo Centralizador:"
                    placeholder="Grupo Centralizador:"
                    options={optionGruposCentralizadores}
                    noOptionsMessage="Grupo não encontrado"
                    labelTooltip={
                      isTrilhaPermitida && (
                        <Info
                          bg="blue"
                          position="mobile-left"
                          text={
                            <>
                              Atualização do campo será feita após validação do <strong>GRUPO CENTRALIZADOR CONSTRUTORAS</strong>
                            </>
                          }
                          tooltipClass="w-4 h-4 relative mt-1"
                        />
                      )
                    }
                    onChange={(e) => onChangeGrupoCentralizador(e)}
                    errors={errors.grupoCentralizadorId}
                    touched={touched.grupoCentralizadorId}
                    isDisabled={true}
                    {...grupoCentralizadorSelect}
                  />
                  <Select
                    name="recebimento"
                    label="Forma de Recebimento NFe:"
                    placeholder="Forma de Recebimento NFe:"
                    options={recebimentoOptions}
                    noOptionsMessage="Forma de Recebimento NFe não encontrada"
                    isRequired
                    onChange={(e) => {
                      onChangeRecebimento(e);
                    }}
                    errors={errors.recebimento}
                    touched={touched.recebimento}
                    {...recebimentoSelect}
                  />
                    <Select
                    name="equipeVendaId"
                    label="Equipe de venda:"
                    placeholder="Equipe de venda:"
                    options={optionsEquipe}
                    noOptionsMessage="Equipe de venda não encontrada"
                    onChange={(e) => {
                      onChangeEquipe(e);
                    }}
                    errors={errors.equipeVendaId}
                    touched={touched.equipeVendaId}
                    {...equipeSelect}
                    isRequired
                    />
                    <Select
                      name="escritorioVendaId"
                      label="Escritório de Venda:"
                      placeholder="Escritório de Venda:"
                      options={optionsEscritorio}
                      noOptionsMessage="Escritório de Venda não encontrado"
                      onChange={(e) => {
                          onChangeEscritorio(e);
                      }}
                      errors={errors.escritorioVendaId}
                      touched={touched.escritorioVendaId}
                      {...escritorioSelect}
                      isRequired
                    />
                    {isTrilhaPermitida && (
                      <Select
                        name="grupoCentralizadorConstrutoraId"
                        label="Grupo Centralizador Construtoras:"
                        placeholder="Grupo Centralizador Construtoras:"
                        options={grupoOptionsLoaded ? grupoOptionsState : (selectedGrupoOption ? [selectedGrupoOption] : [])}
                        noOptionsMessage="Grupo Centralizador Construtoras não encontrado"
                        onChange={onChangeGrupoCentralizadorConstrutora}
                        errors={errors.grupoCentralizadorConstrutoraId}
                        touched={touched.grupoCentralizadorConstrutoraId}
                        isRequired={isTrilhaIMO}
                        {...grupoCentralizadorConstrutoraSelect}
                        loading={grupoLoading}
                        onMenuOpen={loadGrupoOptions}
                        isDisabled={grupoLoading || !values.trilhaId}
                      />
                    )}
                </div>
                <div className="grid gap-x-4 md:grid-cols-6 lg:grid-cols-12 mt-4">
                  <div className="col-span-4">
                    <label className="flex items-center space-x-2">
                      <Field
                        type="checkbox"
                        name="descargaCliente"
                        className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                      />
                      <span className="text-gray-700">Descarga no Cliente</span>
                    </label>
                  </div>
                </div>
              </ContainerForm>

              {usuario?.slugAcessos?.length > 0 && usuario?.ativo && usuario.slugAcessos.includes('disponibilizar-cliente-concorrente') ? (
                <ContainerForm title="Cliente concorrente?">
                  <div className="flex concorrente gap-x-4 md:grid-cols-6 lg:grid-cols-12 mt-4">
                    <div className="col-span-1">
                      <label className="flex items-center space-x-2">
                        <Field
                          type="checkbox"
                          name="concorrente.checkboxSim"
                          onChange={(e) => {
                            setFieldValue("concorrente", {
                              checkboxSim: e.target.checked,
                              checkboxNao: !e.target.checked,
                            });
                          }}
                        />
                        <span className="text-gray-700">Sim</span>
                      </label>
                    </div>
                    <div className="col-span-11">
                      <label className="flex items-center space-x-2">
                        <Field
                          type="checkbox"
                          name="concorrente.checkboxNao"
                          className=""
                          onChange={(e) => {
                            setFieldValue("concorrente", {
                              checkboxSim: !e.target.checked,
                              checkboxNao: e.target.checked,
                            });
                          }}
                        />
                        <span className="text-gray-700">Não</span>
                      </label>
                    </div>
                  </div>
                  {errors.concorrente && touched.concorrente && (
                    <p style={{ color: "red", fontSize: "14px" }}>{errors.concorrente}</p>
                  )}
                  {values.concorrente && values.concorrente.checkboxSim && !values.concorrente.checkboxNao && (
                    <>
                      <h2 className="text-2xl font-bold  pb-3 mt-5">Em quais Produtos?</h2>
                      <div className="max-w-[300px]">
                        <Multiselect
                          name="selectedOptions"
                          options={optionFunilObraProdutos}
                          selectedValues={initialValues.produtos}
                          placeholder=""
                          showArrow
                          style={{ zIndex: 9999 }}
                          showCheckbox={true}
                          customArrow={true}
                          onSelect={(selectedList) => {
                            setFieldValue("produtos", selectedList);
                            setTimeout(() => setFieldTouched("produtos", true));
                          }}
                          onRemove={(selectedList) => {
                            setFieldValue("produtos", selectedList);
                            setTimeout(() => setFieldTouched("produtos", true));
                          }}
                          displayValue="label"
                        />
                        {errors.produtos && touched.produtos && (
                          <p style={{ color: "red", fontSize: "14px" }}>{errors.produtos}</p>
                        )}
                      </div>
                    </>
                  )}
                </ContainerForm>
              ) : null}
            </div>
            {loading && (
              <>
                <div className="spinner__form ">
                  <Loader />
                </div>
              </>
            )}
            <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />
            <ExcluirModal
              isOpen={isConfirmationOpen}
              onClose={HandleRemoveBlockClosed}
              onConfirm={RemoveBlock}
              onCancel={HandleRemoveBlockClosed}
              mensagem={`Tem certeza de que deseja excluir o bloco ${indexBlock}`}
            />
            <ModalAction
              isOpen={isModalOpenAction}
              onClose={closeModalAction}
              title="Deseja cadastrar um limite de crédito?"
              buttonOne="Sim"
              buttonTwo="Não"
              linkOne={SimLimite}
              linkTwo={NaoLimite}
            />
          </Form>

        </>
      )}
    </Formik>

    </>
  );
};

export default ReceiverForm;